import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AnalyticsSummary, ChartData } from '../../types/api';

interface AnalyticsState {
  summary: AnalyticsSummary | null;
  chartData: ChartData[];
  loading: boolean;
  error: string | null;
}

const initialState: AnalyticsState = {
  summary: null,
  chartData: [],
  loading: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSummary: (state, action: PayloadAction<AnalyticsSummary>) => {
      state.summary = action.payload;
    },
    setChartData: (state, action: PayloadAction<ChartData[]>) => {
      state.chartData = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setLoading, setSummary, setChartData, setError, clearError } = analyticsSlice.actions;
export default analyticsSlice.reducer; 